import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { get } from 'lodash';

import config from '../configs/metric-details-config';

import ShowViewershipByDate from './ShowViewershipByDate';

import * as embedActions from '../../actions/embed-actions';
import * as filtersActions from '../../actions/filters-actions';
import * as showActions from '../../actions/show-actions';

import { getLooks } from '../../reducers/embed-reducer';
import { getShow, getFiltersForShow } from '../../reducers/show-reducer';

const mapStateToProps = (state, ownProps) => {
  const showId = get(ownProps, 'match.params.showId', '');
  const show = getShow(showId, state);

  return {
    filters: getFiltersForShow(showId, state),
    looks: getLooks(config.SHOW_VIEWERSHIP_FILTERS.looks, state),
    showName: get(show, 'name', '')
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const showId = get(ownProps, 'match.params.showId', '');

  return {
    embedActions: bindActionCreators(embedActions, dispatch),
    filtersActions: bindActionCreators(filtersActions, dispatch),
    fetchShow: () => dispatch(showActions.getShowData(showId))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ShowViewershipByDate);
